module.exports = __webpack_public_path__ + "static/media/aspect-ratio-icon.b4a9081e.svg";